import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'mustache',
    pure: false,
    standalone: false
})
export class MustachePipe implements PipeTransform {

    transform(template: string, content: any): string {
        if (template) {
            try {
                console.error('mustache non importé');
                const result = 'Mustache.render(template, content)';
                return result;
            } catch (error) {
                return template;
            }
        } else {
            return '';
        }
    }

}
